import * as React from 'react';
import PropTypes from 'prop-types';

import * as gbc from "../../GB/GBConst";

import {RS} from "../../../data/strings/global";
import * as SC from "../../../data/strings/RCStringConst";

import * as Theme from "../../../app/Theme";
import RADAR_LogoFull from "../../../img/RADAR Logo.png";

import TAppBar from '../../APP/TAppBar';

import RCAppBarCustom from './RCAppBarCustom';
import * as RCConst from "../NonVisual/RCConst";

class RCAppBar extends React.Component {

    static propTypes = {

        onAddTasks           : PropTypes.func,

        onDrawerChange       : PropTypes.func,

        language             : PropTypes.number,
        onLanguageChange     : PropTypes.func,

        pageID               : PropTypes.string,
        onPageChange         : PropTypes.func,

        onSideBarArrowClick  : PropTypes.func,

        titleStyle           : PropTypes.object,

    };

    static defaultProps = {

        onAddTasks            : () => console.log('onAddTasks'),

        onDrawerChange       : () => console.log('onDrawerChange'),

        language             : gbc.language.english,
        onLanguageChange     : () => console.log("onLanguageChange"),

        pageID               : "",
        onPageChange         : () => console.log('onPageChange'),

        onSideBarArrowClick  : () => console.log("onSideBarArrowClick"),

        titleStyle           : {},

    };

    state = {

        showAboutDialogBool : false,

    };

    onShowAboutDialogChange = (showAboutDialogBool) => {

        this.setState({

            showAboutDialogBool : showAboutDialogBool,

        });

    };

    render() { // 48

        return (

            <TAppBar
                caption          = {RS(SC.GB_stSampleSizeCalculator)}
                hamburgerStyle   = {{color : Theme.RC_PrimaryColor}}
                onHamburgerClick = {this.props.onSideBarArrowClick}
                showHamburger    = {true}
                style            = {{
                    'minHeight' : this.props.height,
                    background  : Theme.whiteColor,
                    color       : Theme.RC_PalatinatePurple,
                    fontWeight  : "bold",
                }}
                logo             = {
                    <img
                        alt     = {""}
                        onClick = {() => {this.props.onPageChange(RCConst.welcomeForm)}}
                        style   = {{
                            cursor    : "pointer",
                            marginTop : '5px',
                            height    : "48px",
                        }}
                        src    = {RADAR_LogoFull}
                    />
                }
                onTitleClick    = {() => {this.props.onPageChange(RCConst.welcomeForm)}}
                titleStyle      = {this.props.titleStyle}
                // logo          = {
                //     <a
                //         style = {{lineHeight: '10px'}}
                //         href  = "https://ghcosting.org"
                //     >
                //         <img
                //             src  = "./GHCC_dark_line.png"
                //             alt  = "Logo"
                //             style = {{
                //                 background : '#262626',
                //                 padding    : '10px',
                //                 height     : '55px',
                //                 width      : 'auto'
                //             }}
                //         />
                //     </a>
                // }
            >

                <RCAppBarCustom

                    onAddTasks                      = {this.props.onAddTasks}

                    getDataVisChart                 = {this.props.getDataVisChart}

                    onDrawerChange                  = {this.props.onDrawerChange}

                    language                        = {this.props.language}
                    onLanguageChange                = {this.props.onLanguageChange}

                    pageID                          = {this.props.pageID}
                    onPageChange                    = {this.props.onPageChange}

                />

            </TAppBar>

        );
    }
}

export default RCAppBar;